// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2EoYm","label":"Category_label__2zJ5n","content":"Category_content__3iXZX","header":"Category_header__2Yk4A","location":"Category_location__1XKtK"};